// reducers.js
import { combineReducers } from 'redux';

const initialState = {
  locations: [],
  products: [],
  periods: [],
  product_att:[],
  location_att:[],
  filter:[],
};

const filterReducer = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_FILTER_DATA':
      return { ...state, filterdata:action.payload };
    case 'SET_LOCATION_ITEMS':
      return { ...state, locations: action.payload };
    case 'SET_PRODUCT_ITEMS':
      return { ...state, products: action.payload };
    case 'SET_PERIOD_ITEMS':
      return { ...state, periods: action.payload };
    case 'SET_PRODUCT_ATTRIBUTE':
        return { ...state, product_att: action.payload };
    case 'SET_LOCATION_ATTRIBUTE':
      return { ...state, location_att: action.payload };      
    case 'SET_FILTER_POST':
        return { ...state, filter: action.payload };     
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  filter: filterReducer,
});

export default rootReducer;
